<template>
  <success-page-layout
    web-to-mobile-flag="webPremiumPurchased"
    store-badges-button-code="body-20210304-success-page-go1-account-connected"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4">
        {{ $t("headline") }}
      </b-headline>
      <p v-html="$t('copy')" />
    </template>

    <template v-slot:image>
      <join-organisation-image />
    </template>
  </success-page-layout>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import JoinOrganisationImage from "@/pages/success-page/components/join-organisation/image"

export default {
  name: "Go1AccountConnected",
  components: {
    JoinOrganisationImage,
    BHeadline,
    SuccessPageLayout
  },
  i18n: {
    messages: {
      en: {
        headline: "Congrats! Blinkist Premium is all yours",
        copy: "Blinkist is best when you use it on the app. Download it, and get powerful ideas when you need them: anytime, anywhere!"
      },
      de: {
        headline: "Herzlichen Glückwunsch! Blinkist Premium gehört ganz dir",
        copy: "Blinkist ist am Besten, wenn du es in der App verwendest. Lade sie herunter und hole dir starke Ideen, wenn du sie brauchst: jederzeit und überall!"
      }
    }
  }
}
</script>
